'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _constants = require('./constants');

var _utils = require('./utils');

const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


let activeScrollLocks = 0;

class ScrollLock extends _react.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.originalStyles = {}, this.listenerOptions = {
      capture: false,
      passive: false
    }, _temp;
  }

  componentDidMount() {
    if (!canUseDOM) return;

    const { accountForScrollbars, touchScrollTarget } = this.props;
    const target = document.body;
    const targetStyle = target && target.style;

    if (accountForScrollbars) {
      // store any styles already applied to the body
      _constants.STYLE_KEYS.forEach(key => {
        const val = targetStyle && targetStyle[key];
        this.originalStyles[key] = val;
      });
    }

    // apply the lock styles and padding if this is the first scroll lock
    if (accountForScrollbars && activeScrollLocks < 1) {
      const currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
      const clientWidth = document.body ? document.body.clientWidth : 0;
      const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

      Object.keys(_constants.LOCK_STYLES).forEach(key => {
        const val = _constants.LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });

      if (targetStyle) {
        targetStyle.paddingRight = `${adjustedPadding}px`;
      }
    }

    // account for touch devices
    if (target && (0, _utils.isTouchDevice)()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

      // Allow scroll on provided target
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
        touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
      }
    }

    // increment active scroll locks
    activeScrollLocks += 1;
  }
  componentWillUnmount() {
    if (!canUseDOM) return;

    const { accountForScrollbars, touchScrollTarget } = this.props;
    const target = document.body;
    const targetStyle = target && target.style;

    // safely decrement active scroll locks
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    // reapply original body styles, if any
    if (accountForScrollbars && activeScrollLocks < 1) {
      _constants.STYLE_KEYS.forEach(key => {
        const val = this.originalStyles[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    // remove touch listeners
    if (target && (0, _utils.isTouchDevice)()) {
      target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
      }
    }
  }
  render() {
    return null;
  }
}
exports.default = ScrollLock;
ScrollLock.defaultProps = {
  accountForScrollbars: true
};